module.exports = __webpack_public_path__ + "img/close.bc92e112.svg";